import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Maqueta } from '../../../_entities/Maqueta/Maqueta';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaquetaServiceService {

  constructor(private http:HttpClient) { }

  obtenerMaqueta():Observable<Maqueta[]>{
      return this.http.get<Maqueta[]>(environment.API_SECURITY+'/api/Maqueta');
  }
}
